/**
 * 404ページのルートコンポーネント、組織ごとにコピーして拡張
 * 
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/notfound.html > templates/default/notfound.html
 * 
 * 特にカスタマイズが不要なら複製は不要
 */
import { defineComponent, onMounted } from 'vue'
import NotFound from "@/organizations/_default/notfound"
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'

export default defineComponent({
  extends: NotFound,
  components: {
    CosmoHeader, 
    CosmoFooter,
  },
  setup(props, context) {
    const page = NotFound.setup(props, context)

    onMounted(() => {
      console.debug('override 404')
    })
    
    return page
  }
})
